import { useEffect, useState } from "react";
import { supabase } from "../../lib/supabaseClient";
import ProjectPanel, { PROJECT_STATUS } from "./ProjectPanel";

export default function ClientDashboard({ profile }) {
  const [projects, setProjects] = useState([]);
  const [devIds, setDevIds] = useState(new Set());
  const [clientIds, setClientIds] = useState(new Set());
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  const myEmail = (profile.email || "").toLowerCase();

  useEffect(() => {
    (async () => {
      const [pr, mem, cli] = await Promise.all([
        supabase.from("projects").select("*").order("created_at", { ascending: false }),
        supabase.from("project_members").select("project_id").eq("dev_email", myEmail),
        supabase.from("project_clients").select("project_id").eq("email", myEmail),
      ]);
      setProjects(pr.data || []);
      setDevIds(new Set((mem.data || []).map((m) => m.project_id)));
      setClientIds(new Set((cli.data || []).map((m) => m.project_id)));
      setSelected((pr.data && pr.data[0]) || null);
      setLoading(false);
    })();
  }, [myEmail]);

  if (loading) return <p className="text-zinc-500">Chargement…</p>;

  if (projects.length === 0) {
    return (
      <div className="bento p-10 text-center max-w-lg mx-auto">
        <h2 className="font-display text-2xl tracking-tight mb-3">Bienvenue !</h2>
        <p className="text-zinc-400 text-sm leading-relaxed">
          Votre projet apparaîtra ici dès qu'il sera créé. Vous y suivrez chaque étape,
          récupérerez vos livrables et échangerez avec l'équipe ML.
        </p>
      </div>
    );
  }

  const isDev = selected ? devIds.has(selected.id) : false;
  const isClientOf = selected
    ? (clientIds.has(selected.id) || (selected.client_email || "").toLowerCase() === myEmail)
    : false;

  return (
    <div className="grid lg:grid-cols-12 gap-8">
      {projects.length > 1 && (
        <div className="lg:col-span-3">
          <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500 mb-4">Mes projets</div>
          <div className="space-y-2">
            {projects.map((p) => (
              <button key={p.id} onClick={() => setSelected(p)}
                className={`w-full text-left rounded-xl border px-4 py-3 transition-colors ${selected?.id === p.id ? "border-[var(--accent)]/50 bg-[var(--accent)]/[0.06]" : "border-white/[0.06] hover:border-white/20"}`}>
                <div className="text-sm text-zinc-200 flex items-center gap-2">
                  {p.name}
                  {devIds.has(p.id) && <span className="rounded-full bg-white/10 px-1.5 py-0.5 text-[9px] uppercase tracking-wider text-zinc-400">Dev</span>}
                </div>
                <div className="text-[11px] text-zinc-500 mt-0.5">{PROJECT_STATUS.find((s) => s.id === p.status)?.label}</div>
              </button>
            ))}
          </div>
        </div>
      )}
      <div className={projects.length > 1 ? "lg:col-span-9" : "lg:col-span-12 w-full"}>
        {selected && (
          <ProjectPanel
            project={selected}
            profile={profile}
            isAdmin={false}
            canManage={isDev}
            canValidate={isClientOf}
          />
        )}
      </div>
    </div>
  );
}
